import React, { useState, useEffect } from 'react';
import { Box, Typography, Alert, CircularProgress } from '@mui/material';
import BookingList from '../components/bookings/BookingList';
import BookingForm from '../components/bookings/BookingForm';
import { Booking } from '../types';
import { bookingService } from '../services/bookingService';
import './BookingsPage.css';

const BookingsPage: React.FC = () => {
    const [showForm, setShowForm] = useState(false);
    const [editingBooking, setEditingBooking] = useState<Booking | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const handleEdit = (booking: Booking) => {
        setEditingBooking(booking);
        setShowForm(true);
    };

    const handleAdd = () => {
        setEditingBooking(null);
        setShowForm(true);
    };

    const handleSave = async (booking: Booking) => {
        setLoading(true);
        setError(null);
        try {
            if (editingBooking?.id) {
                await bookingService.updateBooking(editingBooking.id, booking);
                setSuccess('Prenotazione aggiornata con successo');
            } else {
                await bookingService.createBooking(booking);
                setSuccess('Prenotazione creata con successo');
            }
            setShowForm(false);
            setEditingBooking(null);
            // Refresh the list by triggering a re-render
            window.location.reload();
        } catch (err) {
            setError('Errore nel salvataggio della prenotazione: ' + (err as Error).message);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setShowForm(false);
        setEditingBooking(null);
    };

    return (
        <Box className="bookings-page">
            {/* Messages */}
            {error && (
                <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
                    {error}
                </Alert>
            )}
            {success && (
                <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess(null)}>
                    {success}
                </Alert>
            )}

            {/* Loading overlay */}
            {loading && (
                <Box
                    position="fixed"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    bgcolor="rgba(0,0,0,0.5)"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    zIndex={9999}
                >
                    <CircularProgress size={60} />
                </Box>
            )}

            {/* Main content */}
            <BookingList
                onEdit={handleEdit}
                onAdd={handleAdd}
            />

            {/* Form dialog */}
            {showForm && (
                <BookingForm
                    booking={editingBooking}
                    onSave={handleSave}
                    onCancel={handleCancel}
                    open={showForm}
                />
            )}
        </Box>
    );
};

export default BookingsPage;
